var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.984,
    height: 17.984,
    viewBox: "0 0 17.984 17.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-call",
    "data-name": "Icon ionic-md-call",
    d: "M20.352,16.156a10.944,10.944,0,0,1-3.31-.513.872.872,0,0,0-.932.233l-2.052,2.051A14.022,14.022,0,0,1,7.9,11.773L9.955,9.722a.972.972,0,0,0,.233-.932,10.141,10.141,0,0,1-.56-3.357A.935.935,0,0,0,8.7,4.5H5.432a.935.935,0,0,0-.932.932A15.839,15.839,0,0,0,20.352,21.284a.935.935,0,0,0,.932-.932V17.088A.935.935,0,0,0,20.352,16.156Z",
    transform: "translate(-3.9 -3.9)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNumber);
export default __webpack_public_path__ + "static/media/mobileNumber.c7f17b12ca6770e55ccaeff7544ead47.svg";
export { ForwardRef as ReactComponent };